const config = {
  colors: {
    Activity: "#F9A825",
    Attendance: "#0097A7",
    Broadcast: "#FF5722",
    Flag: "#f44336",
    Kpi: "#6D4C41",
    Leave: "#f02070",
    Meeting: "#3F51B5",
    Overtime: "#ff0000",
    Team: "#546E7A",
    Ticket: "#8E24AA",
    ToDo: "#00C853",
    Work: "#4CAF50",
    bgcolor: "#f8f9fb",
Expense:"#25a244",
    Primary: "#29B6F6",
    PrimaryLight: "#29B6F6",
    fadePrimary: "#4D29B6F6",
    colorPrimaryDark: "#00b2cc",
    colorAccent: "#D81B60",

    mtrl_textinput_default_box_stroke_color: "#546e7a",
    hintcolor: "#464545",
    cardbg: "#B0B0B6",
    transparent: "#00FFFFFF",
    Gray: "#9B9B9B",
    ActivityBg: "#ECEFF1",
    White: "#FFFFFF",
    Black: "#000000",
    DarkGray: "#C4C4C4",
    DarkSeaGreen: "#8FBC8F",
    Blue: "#1E88E5",
    TranslucentRed: "#81F44336",
    Red: "#F44336",
    Green: "#4CAF50",
    Yellow: "#FFB700",

    ShiftClosed: "#F44336",
    ShiftOpen: "#4CAF50",
    ShiftOpenLight: "#1B00C853",

    OffWhite: "#EBEBEB",
    GraphTop: "#82B1FF",
    GraphBottom: "#5E82B1FF",
    gridstroke: "#5FB9B0",
    AddActivityBtnBg: "#39D5CDCD",

    DurationSelectedColor: "#304FFE",
    DurationUnselectedColor: "#3B000000",
    RetryBtnColor: "#444343",

    Training: "#FDD835",
    Planning: "#26C6DA",
    Sales: "#3F51B5",
    Finance: "#FF9900",
    HR: "#AB47BC",
    IT: "#9CCC65",
    Operations: "#EC407A",
    Logistics: "#8D6E63",
    Miscellaneous: "#FF5050",
    Other: "#90A4AE",

    ScoreRed: "#FF1200",
    ScoreYellow: "#FDD835",
    ScoreGreen: "#00FF0A",

    TicketColor: "#8E24AA",
    MeetingColor: "#3F51B5",
    ActivityColor: "#F9A825",
    WorkColor: "#4CAF50",
    FlagColor: "#F44336",
    AttendanceColor: "#0097A7",
    BroadcastColor: "#FF5722",
    LeaveColor: "#90CAF9",
    TeamColor: "#546E7A",
    ToDoColor: "#00C853",
    OvertimeColor: "#FF7043",

    table_view_default_text_color: "#000000",
    header_line_color: "#29B6F6",
    cell_background_color: "#FFFFFF",
    white_ripple_color: "#59FFFFFF",

    NormalTickColor: "#E6E6E6",
    SeenTickColor: "#006AFF",
    ShadowTickColor: "#A41E1E1E",

    LeftChatheadColor: "#DBDBDB",
    RightChatheadColor: "#00BCD4",
    LeftChatHeadTextColor: "#000000",
    RightChatHeadTextColor: "#FFFFFF",

    TransparentBlack: "#77000000",
    calendar_selected_day_bg: "#29B6F6",
    calendar_selected_range_bg: "#29B6F6",

    WatermarkColor: "#4FFFFFFF",
    WatermarkShadowColor: "#36000000",

    NormalTicketColor: "#FFFFFF",
    DueTodayTicketColor: "#FFF8E1",
    OverDueTicketColor: "#FFEBEE"
  }
};

export default config;
